<template>
  <div class=" md:mx-auto text-left mt-24 pt-24 px-24 justify-self-start
  min-h-screen bg-gray-100 w-5/6 mx-auto top-0">
    <lesson-summary :lesson="lesson" :notShowTitle="true" />
    <div class="text-center mt-16 w-full uppercase text-lg font-bold text-red-700">
      {{$t('payments.failed')}}
    </div>
    <div class="bg-white bg-opacity-90 p-10">
      <div class="w-2/3 mx-auto font-sans-serif">
        {{$t('payments.default')}}
        <default-payment-method class="mt-10" />
        <div class="flex justify-between mt-5">
          <button class="rounded bg-beige-academy-300 w-1/4 p-2 mt-5 ml-2 uppercase font-semibold
            text-white hover:bg-beige-academy-500 transform text-sm hover:scale-105"
            @click="notDefault">
              {{$t('payments.change')}}
          </button>
        </div>
      </div>
      <div v-if="!student.default_payment_method || !useDefault"
        class="w-2/3 mx-auto mt-20 font-sans-serif">
          {{$t('payments.choose')}}
        <payment-methods class="mt-5" v-model="defaultPaymentMethod"
          @stripe-changed="stripePaymentMethodId = $event" />
      </div>

    </div>
    <div class="flex flex-col text-center items-center mt-2">
        <button class="rounded bg-beige-academy-300 w-1/2 p-3 m-5 uppercase font-semibold
          text-white hover:bg-beige-academy-500 transform hover:scale-105"
          @click="updateLessonPayment"
          :class="isLoading ? 'loader' : ''">
            {{$t('payments.updateLesson')}}
        </button>
      </div>
  </div>
</template>

<script>
import { getLesson } from '@/services/LessonService';
import { mapGetters } from 'vuex';
import axios from 'axios';
import LessonSummary from '../components/payment/LessonSummary.vue';
import DefaultPaymentMethod from '../components/payment/DefaultPaymentMethod.vue';
import PaymentMethods from '../components/payment/PaymentMethods.vue';

export default {
  data() {
    return {
      lesson: {},

      defaultPaymentMethod: 'card',
      stripePaymentMethodId: null,

      useDefault: true,

      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      student: 'auth/student',
    }),
  },

  components: {
    LessonSummary,
    DefaultPaymentMethod,
    PaymentMethods,
  },

  created() {
    getLesson(this.$route.query.lesson).then(({ data }) => {
      this.lesson = data;
    });
  },

  mounted() {
    this.defaultPaymentMethod = this.student.default_payment_method;
    if (this.student && !this.student.default_payment_method) {
      this.useDefault = false;
    }
  },

  methods: {
    notDefault() {
      this.useDefault = false;
    },

    updateLessonPayment() {
      this.isLoading = true;
      axios.post(`/api/students/${this.student.id}/update-payment-method`,
        { type: this.defaultPaymentMethod, stripe_id: this.stripePaymentMethodId }).then(() => {
        axios.put(`/api/lessons/${this.lesson.booking_id}/update-payment-method`).then(({ data }) => {
          if (this.defaultPaymentMethod === 'paypal') {
            this.loadPaypal(data);
            return;
          }
          this.createNotification('success', this.$t('payments.success'));
          this.$router.push(`/student-dashboard/classrooms/${this.$route.query.classroom}`);
        }).catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
      }).catch((error) => {
        this.isLoading = false;
        console.log(error);
      });
    },

    loadPaypal(path) {
      window.location.href = path;
    },
  },
};
</script>
